module.exports = __webpack_public_path__ + "img/PXL_20230525_093453911.f0095a0a.jpg";